import { DisplayAcademy } from './display-academy';
import { SearchAcademy } from './search-academy';

// prettier-ignore
export const WEB_COLLECTION_MAP = {
  'DisplayAcademy': DisplayAcademy,
  'SearchAcademy' : SearchAcademy
}
